(() => {
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hex = h => { h = (h || '').trim().replace('#', ''); if (h.length === 3) h = h.replace(/./g, c => c + c); const n = parseInt(h, 16) || 0; return [n >> 16 & 255, n >> 8 & 255, n & 255]; };
  const luma = c => (c[0] * .299 + c[1] * .587 + c[2] * .114) / 255;
  const strength = L => .05 + .95 * Math.pow(Math.min(1, Math.max(0, (L - .15) / .83)), 1.6);
  const level = L => L >= .8 ? 1 : L >= .6 ? 2 : L >= .35 ? 3 : 4;
  const FONT = 'PTSGeist, system-ui, -apple-system, sans-serif';

  const text = (c, s, x, y, size, fill, stroke, sw, align = 'center') => {
    c.font = `900 ${size}px ${FONT}`;
    c.textAlign = align; c.textBaseline = 'alphabetic'; c.lineJoin = 'round';
    if (stroke) { c.strokeStyle = stroke; c.lineWidth = sw * 2; c.strokeText(s, x, y); }
    c.fillStyle = fill; c.fillText(s, x, y);
  };
  const sparkle = (c, x, y, r, fill, stroke) => {
    c.beginPath();
    for (let i = 0; i < 8; i++) { const a = i * Math.PI / 4 - Math.PI / 2, rr = i % 2 ? r * .32 : r; c.lineTo(x + Math.cos(a) * rr, y + Math.sin(a) * rr); }
    c.closePath(); c.lineJoin = 'round'; c.strokeStyle = stroke; c.lineWidth = 7; c.stroke(); c.fillStyle = fill; c.fill();
  };
  const bat = (c, x, y, s, fill) => {
    c.save(); c.translate(x, y); c.scale(s, s); c.fillStyle = fill; c.beginPath();
    c.moveTo(0, -6); c.quadraticCurveTo(14, -22, 46, -20); c.quadraticCurveTo(38, -12, 40, 0); c.quadraticCurveTo(30, -6, 22, 4); c.quadraticCurveTo(14, -2, 6, 8);
    c.lineTo(0, 12); c.lineTo(-6, 8); c.quadraticCurveTo(-14, -2, -22, 4); c.quadraticCurveTo(-30, -6, -40, 0); c.quadraticCurveTo(-38, -12, -46, -20); c.quadraticCurveTo(-14, -22, 0, -6);
    c.fill(); c.restore();
  };
  const zig = (c, x0, x1, y, amp, step, col, ink) => {
    c.beginPath();
    for (let x = x0, i = 0; x <= x1; x += step / 2, i++) c.lineTo(x, y + (i % 2 ? -amp : amp));
    c.lineJoin = 'round'; c.lineCap = 'round';
    c.strokeStyle = ink; c.lineWidth = 34; c.stroke();
    c.strokeStyle = col; c.lineWidth = 20; c.stroke();
  };
  const rrect = (c, x, y, w, h, r) => { c.beginPath(); if (c.roundRect) c.roundRect(x, y, w, h, r); else c.rect(x, y, w, h); };

  const ART = {
    boo(c) {
      const ink = '#1d1d1f';
      c.fillStyle = '#ffe7a3'; c.beginPath(); c.arc(500, 250, 205, 0, Math.PI * 2); c.fill();
      c.fillStyle = '#f5d685';
      [[392, 160, 26], [610, 140, 16], [640, 330, 22], [360, 330, 14]].forEach(([x, y, r]) => { c.beginPath(); c.arc(x, y, r, 0, Math.PI * 2); c.fill(); });
      c.beginPath(); c.moveTo(372, 250); c.arc(500, 250, 128, Math.PI, 0); c.lineTo(628, 440);
      for (let i = 0; i < 4; i++) { const xa = 628 - i * 64; c.quadraticCurveTo(xa - 16, 478, xa - 32, 440); c.quadraticCurveTo(xa - 48, 402, xa - 64, 440); }
      c.closePath(); c.fillStyle = '#ffffff'; c.fill(); c.lineJoin = 'round'; c.strokeStyle = ink; c.lineWidth = 13; c.stroke();
      c.fillStyle = ink;
      c.beginPath(); c.ellipse(458, 262, 17, 26, 0, 0, Math.PI * 2); c.fill();
      c.beginPath(); c.ellipse(542, 262, 17, 26, 0, 0, Math.PI * 2); c.fill();
      c.beginPath(); c.ellipse(500, 338, 22, 30, 0, 0, Math.PI * 2); c.fill();
      bat(c, 165, 150, 1.6, '#3b2a5a'); bat(c, 845, 115, 1.2, '#3b2a5a');
      sparkle(c, 170, 390, 26, '#fff3c4', ink); sparkle(c, 845, 330, 22, '#fff3c4', ink); sparkle(c, 790, 520, 16, '#fff3c4', ink);
      text(c, 'BOO!', 500, 712, 220, '#ff8a1f', ink, 12);
    },
    run(c) {
      const ink = '#14213d';
      c.save(); c.fillStyle = '#fff3c4'; c.beginPath(); c.arc(810, 150, 104, 0, Math.PI * 2); c.fill();
      c.globalCompositeOperation = 'destination-out'; c.beginPath(); c.arc(856, 118, 92, 0, Math.PI * 2); c.fill(); c.restore();
      sparkle(c, 640, 90, 20, '#ffffff', ink); sparkle(c, 920, 300, 16, '#ffffff', ink); sparkle(c, 120, 140, 24, '#ffffff', ink);
      text(c, 'NIGHT', 470, 410, 210, '#9ad8ff', ink, 11);
      c.font = `900 250px ${FONT}`;
      const rw = c.measureText('RUN').width, bw = 240, total = rw + 34 + bw, x0 = 520 - total / 2;
      for (let i = 0; i < 3; i++) { rrect(c, x0 - 120 + i * 16, 520 + i * 44, 92 - i * 16, 22, 11); c.fillStyle = '#9ad8ff'; c.fill(); c.strokeStyle = ink; c.lineWidth = 7; c.stroke(); }
      text(c, 'RUN', x0, 668, 250, '#ffffff', ink, 12, 'left');
      rrect(c, x0 + rw + 34, 482, bw, 186, 40); c.fillStyle = ink; c.fill();
      text(c, '5K', x0 + rw + 34 + bw / 2, 630, 150, '#ffe14d', null, 0);
    },
    party(c) {
      const ink = '#1d1d1f';
      zig(c, 140, 860, 130, 30, 92, '#5ff2ff', ink);
      c.font = `900 280px ${FONT}`;
      const w = c.measureText('GLOW').width, g = c.createLinearGradient(500 - w / 2, 0, 500 + w / 2, 0);
      g.addColorStop(0, '#ff4fa8'); g.addColorStop(.55, '#ffb347'); g.addColorStop(1, '#ffe14d');
      text(c, 'GLOW', 500, 470, 280, g, ink, 13);
      text(c, 'CREW', 500, 630, 140, '#ffffff', ink, 10);
      zig(c, 220, 780, 702, 22, 70, '#b98cff', ink);
      [[110, 300, '#ffe14d'], [900, 260, '#ff4fa8'], [70, 560, '#5ff2ff'], [930, 520, '#ffe14d'], [170, 690, '#ff4fa8'], [840, 690, '#5ff2ff']].forEach(([x, y, col], i) => {
        c.beginPath(); if (i % 2) c.arc(x, y, 20, 0, Math.PI * 2); else { c.moveTo(x, y - 24); c.lineTo(x + 22, y + 16); c.lineTo(x - 22, y + 16); c.closePath(); }
        c.fillStyle = col; c.fill(); c.strokeStyle = ink; c.lineWidth = 7; c.lineJoin = 'round'; c.stroke();
      });
    }
  };

  const Room = room => {
    const frame = room.querySelector('[data-ptw-sim]');
    if (!frame) return;
    const [cvD, cvN, cvG] = frame.querySelectorAll('canvas'), vig = frame.querySelector('.ptw-frame__vig');
    const sw = room.querySelector('[data-ptw-switch]'), swText = room.querySelector('[data-ptw-switch-text]');
    const badge = room.querySelector('[data-ptw-badge]'), read = room.querySelector('[data-ptw-read]');
    const charge = room.querySelector('[data-ptw-charge]'), time = room.querySelector('[data-ptw-time]'), again = room.querySelector('[data-ptw-recharge]');
    const chips = [...room.querySelectorAll('[data-ptw-design]')], shirts = [...room.querySelectorAll('[data-ptw-shirt]')];
    const glowRGB = hex(getComputedStyle(room).getPropertyValue('--glow') || '#c8ff8c');
    let design = frame.dataset.design || 'boo', shirt = hex(frame.dataset.shirt || '#f4f4f1');
    let lights = true, blend = 0, t = 0, playing = false, c0 = .85, visible = false, raf = 0, last = 0, used = false, built = false, lvl = '', bw = 0, timer = 0;

    const build = () => {
      const r = frame.getBoundingClientRect();
      if (!r.width) return;
      const k = Math.min(window.devicePixelRatio || 1, 1.5), W = Math.round(r.width * k), H = Math.round(r.height * k);
      bw = r.width;
      [cvD, cvN, cvG].forEach(c => { c.width = W; c.height = H; });
      const off = document.createElement('canvas'); off.width = W; off.height = H;
      const o = off.getContext('2d'), sc = Math.min(W * (W / H < 1.2 ? .98 : .88) / 1000, H * .8 / 760);
      o.translate(W / 2, H / 2); o.scale(sc, sc); o.translate(-500, -390);
      (ART[design] || ART.boo)(o);
      const src = o.getImageData(0, 0, W, H).data;
      const dx = cvD.getContext('2d'), nx = cvN.getContext('2d'), gx = cvG.getContext('2d');
      const day = dx.createImageData(W, H), night = nx.createImageData(W, H), gl = gx.createImageData(W, H);
      const d = day.data, n = night.data, g = gl.data, sl = luma(shirt), light = sl > .5;
      for (let y = 0, p = 0; y < H; y++) {
        const vy = y / H - .5;
        for (let x = 0; x < W; x++, p += 4) {
          const vx = x / W - .5, v = 1 - (vx * vx + vy * vy) * (light ? .16 : .45);
          const knit = ((x >> 1) + (y >> 1)) & 1 ? 1.4 : -1.4, nz = (Math.random() - .5) * (light ? 6 : 8) + knit;
          let r0 = shirt[0] * v + nz, g0 = shirt[1] * v + nz, b0 = shirt[2] * v + nz;
          const a = src[p + 3] / 255;
          if (a) {
            const tex = .95 + ((r0 + g0 + b0) / 765 - sl) * .5;
            const sr = src[p], sg = src[p + 1], sb = src[p + 2];
            r0 = sr * tex * a + r0 * (1 - a); g0 = sg * tex * a + g0 * (1 - a); b0 = sb * tex * a + b0 * (1 - a);
            const L = (sr * .299 + sg * .587 + sb * .114) / 255, s = strength(L), wm = Math.max(0, (s - .85) / .15) * .3;
            g[p] = glowRGB[0] + (255 - glowRGB[0]) * wm; g[p + 1] = glowRGB[1] + (255 - glowRGB[1]) * wm; g[p + 2] = glowRGB[2] + (255 - glowRGB[2]) * wm; g[p + 3] = 255 * a * s;
          }
          d[p] = r0; d[p + 1] = g0; d[p + 2] = b0; d[p + 3] = 255;
          n[p] = r0 * .07 + 3; n[p + 1] = g0 * .07 + 5; n[p + 2] = b0 * .075 + 11; n[p + 3] = 255;
        }
      }
      dx.putImageData(day, 0, 0); nx.putImageData(night, 0, 0); gx.putImageData(gl, 0, 0);
      let prev = cvG;
      const blooms = [4, 12, 28].map(f => {
        const c = document.createElement('canvas'); c.width = Math.max(1, Math.round(W / f)); c.height = Math.max(1, Math.round(H / f));
        const x = c.getContext('2d'); x.imageSmoothingQuality = 'high'; x.drawImage(prev, 0, 0, c.width, c.height); prev = c; return c;
      });
      gx.globalCompositeOperation = 'destination-over'; gx.imageSmoothingQuality = 'high';
      gx.globalAlpha = .9; gx.drawImage(blooms[1], 0, 0, W, H);
      gx.globalAlpha = .75; gx.drawImage(blooms[2], 0, 0, W, H);
      gx.globalAlpha = 1; gx.globalCompositeOperation = 'source-over';
      built = true;
      paint();
    };

    const glowNow = () => Math.min(1, c0 / Math.pow(1 + 2.4 * t, 1.35));
    const paint = () => {
      const e = blend < .5 ? 2 * blend * blend : 1 - Math.pow(-2 * blend + 2, 2) / 2;
      const I = glowNow(), sf = luma(shirt) > .5 ? 1 : .6;
      cvN.style.opacity = e.toFixed(3); vig.style.opacity = e.toFixed(3);
      cvG.style.opacity = Math.min(1, e * I * sf * 1.2).toFixed(3);
      if (time) { time.value = Math.round(t * 1000); time.setAttribute('aria-valuetext', lights ? read.dataset.on : readout(I)); }
      const now = lights ? 'on' : String(I >= .5 ? 1 : I >= .3 ? 2 : I >= .19 ? 3 : 4);
      const key = now + (luma(shirt) > .5 ? '' : 'd');
      if (key !== lvl) { lvl = key; read.textContent = lights ? read.dataset.on : readout(I) + (luma(shirt) > .5 ? '' : ' ' + read.dataset.dark); }
    };
    const readout = I => read.dataset['r' + (I >= .5 ? 1 : I >= .3 ? 2 : I >= .19 ? 3 : 4)];

    const tick = now => {
      raf = 0;
      if (!visible || document.hidden) { last = 0; return; }
      const dt = last ? Math.min(64, now - last) : 16; last = now;
      const target = lights ? 0 : 1;
      if (still) blend = target; else if (blend !== target) { const s = dt / 700; blend = target > blend ? Math.min(target, blend + s) : Math.max(target, blend - s); }
      if (playing && !lights && blend > .5) { t = Math.min(1, t + dt / 16000); if (t >= 1) playing = false; }
      paint();
      if (blend !== target || playing) raf = requestAnimationFrame(tick); else last = 0;
    };
    const kick = () => { if (!raf && visible) raf = requestAnimationFrame(tick); };

    const setLights = on => {
      lights = on;
      room.dataset.lights = on ? 'on' : 'off';
      sw.setAttribute('aria-checked', on ? 'true' : 'false');
      swText.textContent = on ? swText.dataset.on : swText.dataset.off;
      badge.textContent = on ? badge.dataset.on : badge.dataset.off;
      lvl = '';
      if (still) blend = on ? 0 : 1;
      paint(); kick();
    };
    const touch = () => { used = true; clearTimeout(timer); sw.classList.add('is-used'); };

    sw.addEventListener('click', () => {
      touch();
      if (lights) { t = 0; playing = !still; }
      else playing = false;
      setLights(!lights);
    });
    time && time.addEventListener('input', () => { touch(); playing = false; t = +time.value / 1000; if (lights) setLights(false); else { lvl = ''; paint(); } });
    charge && charge.addEventListener('input', () => { touch(); c0 = .3 + .7 * (+charge.value / 100); charge.setAttribute('aria-valuetext', charge.value + '%'); lvl = ''; paint(); });
    again && again.addEventListener('click', () => {
      touch(); t = 0; playing = false;
      if (still) { setLights(false); return; }
      setLights(true);
      timer = setTimeout(() => { playing = true; setLights(false); }, 900);
    });
    chips.forEach(b => b.addEventListener('click', () => { chips.forEach(o => o.setAttribute('aria-pressed', o === b ? 'true' : 'false')); design = b.dataset.ptwDesign; build(); }));
    shirts.forEach(b => b.addEventListener('click', () => { shirts.forEach(o => o.setAttribute('aria-pressed', o === b ? 'true' : 'false')); shirt = hex(b.dataset.ptwShirt); frame.style.setProperty('--shirt', b.dataset.ptwShirt); lvl = ''; build(); }));

    let rt = 0;
    new ResizeObserver(() => { clearTimeout(rt); rt = setTimeout(() => { if (built && Math.abs(frame.getBoundingClientRect().width - bw) > 1) build(); }, 150); }).observe(frame);
    const ready = document.fonts && document.fonts.load ? document.fonts.load(`900 100px ${FONT}`).catch(() => {}) : Promise.resolve();
    ready.then(() => {
      new IntersectionObserver(es => es.forEach(e => {
        visible = e.isIntersecting;
        room.classList.toggle('is-vis', visible);
        if (visible && !built) build();
        if (visible) kick();
        if (e.intersectionRatio >= .55 && !used && !still) { used = true; timer = setTimeout(() => { t = 0; playing = true; setLights(false); }, 1600); }
      }), { threshold: [0, .55] }).observe(frame);
    });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) kick(); });
  };

  const Check = box => {
    const inks = [...box.querySelectorAll('[data-ptw-ink]')], custom = box.querySelector('[data-ptw-ink-custom]');
    const seg = [...box.querySelectorAll('[data-ptw-gc-shirt]')];
    const day = box.querySelector('[data-ptw-gc-day]'), night = box.querySelector('.ptw-gc__pane--night');
    const meter = box.querySelector('[data-ptw-meter]'), title = box.querySelector('[data-ptw-gc-title]'), txt = box.querySelector('[data-ptw-gc-text]');
    const on = inks.find(b => b.getAttribute('aria-pressed') === 'true') || inks[0];
    if (on) on.setAttribute('aria-pressed', 'true');
    let ink = on ? on.dataset.ptwInk : '#ffffff', dark = false;
    const update = () => {
      const L = luma(hex(ink)), lv = Math.min(4, level(L) + (dark ? 1 : 0));
      box.style.setProperty('--ink-c', ink);
      day.style.setProperty('--gc-shirt', dark ? '#17181c' : '#f4f4f1');
      night.style.setProperty('--g', (strength(L) * (dark ? .6 : 1)).toFixed(3));
      meter.dataset.level = lv;
      title.textContent = title.dataset['t' + lv];
      txt.textContent = txt.dataset['t' + lv] + (dark ? ' ' + txt.dataset.dark : '');
    };
    inks.forEach(b => b.addEventListener('click', () => { inks.forEach(o => o.setAttribute('aria-pressed', o === b ? 'true' : 'false')); custom && custom.parentElement.classList.remove('is-on'); ink = b.dataset.ptwInk; update(); }));
    custom && custom.addEventListener('input', () => { inks.forEach(o => o.setAttribute('aria-pressed', 'false')); custom.parentElement.classList.add('is-on'); ink = custom.value; update(); });
    seg.forEach(b => b.addEventListener('click', () => { seg.forEach(o => o.setAttribute('aria-pressed', o === b ? 'true' : 'false')); dark = b.dataset.ptwGcShirt === 'dark'; update(); }));
    update();
  };

  const Uses = sec => {
    const sw = sec.querySelector('[data-ptw-uses-switch]');
    if (!sw) return;
    const lab = sw.querySelector('[data-on]');
    sw.addEventListener('click', () => {
      const on = sw.getAttribute('aria-checked') !== 'true';
      sw.setAttribute('aria-checked', on ? 'true' : 'false');
      sec.classList.toggle('is-dark', on);
      lab.textContent = on ? lab.dataset.on : lab.dataset.off;
    });
  };

  const TEE = 'M12 1.6C13.2 3.4 18.8 3.4 20 1.6L25.6 2.7 31 8.3 27.5 11.7 26 10.3V30.4H6V10.3L4.5 11.7 1 8.3 6.4 2.7Z';
  const GAR = {
    tee: { vb: [32, 32], i: 0, svg: `<path class="ptw-fit__garment" d="${TEE}"/><path class="ptw-fit__collar" d="M12 1.6C13.2 3.4 18.8 3.4 20 1.6"/>` },
    back: { vb: [32, 32], i: 1, svg: `<path class="ptw-fit__garment" d="${TEE.replace('C13.2 3.4 18.8 3.4', 'C13.2 2.3 18.8 2.3')}"/><path class="ptw-fit__collar" d="M12 1.6C13.2 2.3 18.8 2.3 20 1.6"/>` },
    youth: { vb: [32, 32], i: 2, svg: `<g transform="translate(3.2 2.4) scale(.8)"><path class="ptw-fit__garment" d="${TEE}"/><path class="ptw-fit__collar" d="M12 1.6C13.2 3.4 18.8 3.4 20 1.6"/></g>` },
    cap: { vb: [10, 7.4], i: 3, svg: '<path class="ptw-fit__garment" d="M1.2 5.6C1.2 2.2 3 .7 5 .7S8.8 2.2 8.8 5.6Z"/><path class="ptw-fit__seam" d="M5 .7V5.6M3.1 1.2C2.5 2.4 2.4 4 2.5 5.6M6.9 1.2C7.5 2.4 7.6 4 7.5 5.6"/><path class="ptw-fit__brim" d="M.3 5.6Q5 8 9.7 5.6Q5 6.5.3 5.6Z"/>' }
  };
  const dims = v => { const m = (v || '').match(/([\d.]+)\D+([\d.]+)/); return m ? [+m[1], +m[2]] : [0, 0]; };
  const Fit = box => {
    const stage = box.querySelector('.ptw-fit__stage'), svg = box.querySelector('[data-ptw-fit-svg]'), gar = svg.querySelector('[data-ptw-fit-garment]');
    const print = svg.querySelector('[data-ptw-fit-print]'), rect = print.querySelector('rect'), art = print.querySelector('svg');
    const dl = { w: svg.querySelector('[data-d=w]'), h: svg.querySelector('[data-d=h]') }, dt = { w: svg.querySelector('[data-t=w]'), h: svg.querySelector('[data-t=h]') };
    const spots = [...box.querySelectorAll('[data-ptw-spot]')], sizes = [...box.querySelectorAll('[data-ptw-size]')];
    const badge = box.querySelector('[data-ptw-fit-badge]'), title = box.querySelector('[data-ptw-fit-title]'), txt = box.querySelector('[data-ptw-fit-text]');
    const lights = box.querySelector('[data-ptw-fit-lights]'), labels = (box.dataset.glabels || '').split('|');
    let spot = spots[0], size = '';
    const list = sp => (sp.dataset.sizes || '').split(',').map(x => x.trim()).filter(Boolean);
    const draw = () => {
      if (!spot) return;
      const g = GAR[spot.dataset.garment] || GAR.tee, [VW, VH] = g.vb, [w, h] = dims(size);
      svg.setAttribute('viewBox', `0 0 ${VW} ${VH}`);
      if (gar.dataset.k !== spot.dataset.garment) { gar.innerHTML = g.svg; gar.dataset.k = spot.dataset.garment; }
      const X = +spot.dataset.x || VW / 2, Y = +spot.dataset.y || VH / 2, x0 = X - w / 2, y0 = spot.dataset.anchor === 'top' ? Y : Y - h / 2;
      [rect, art].forEach(el => { el.setAttribute('x', x0); el.setAttribute('y', y0); el.setAttribute('width', w); el.setAttribute('height', h); });
      rect.style.strokeWidth = VW * .004;
      const narrow = svg.getBoundingClientRect().width < 420, fs = VW * (narrow ? .045 : .032), gap = VW * .022, sw = VW * (narrow ? .004 : .003);
      const hy = Math.max(fs * 1.4, y0 - gap);
      dl.w.setAttribute('x1', x0); dl.w.setAttribute('x2', x0 + w); dl.w.setAttribute('y1', hy); dl.w.setAttribute('y2', hy);
      dt.w.setAttribute('x', X); dt.w.setAttribute('y', hy - gap * .6); dt.w.setAttribute('font-size', fs); dt.w.textContent = w + ' in';
      const right = x0 + w + gap + fs * 2.6 < VW, vx = right ? x0 + w + gap : x0 - gap;
      dl.h.setAttribute('x1', vx); dl.h.setAttribute('x2', vx); dl.h.setAttribute('y1', y0); dl.h.setAttribute('y2', y0 + h);
      dt.h.setAttribute('x', right ? vx + gap * .6 : vx - gap * .6); dt.h.setAttribute('y', y0 + h / 2); dt.h.setAttribute('text-anchor', right ? 'start' : 'end'); dt.h.setAttribute('font-size', fs); dt.h.textContent = h + ' in';
      [dl.w, dl.h].forEach(l => { l.style.strokeWidth = sw; });
      badge.textContent = labels[g.i] || '';
      const rec = list(spot), area = w * h;
      sizes.forEach(b => { const on = rec.includes(b.dataset.ptwSize); on ? b.setAttribute('data-rec', '') : b.removeAttribute('data-rec'); b.setAttribute('aria-pressed', b.dataset.ptwSize === size ? 'true' : 'false'); });
      title.textContent = `${w} × ${h} in · ${spot.textContent.trim()}`;
      if (!rec.length || rec.includes(size)) txt.textContent = txt.dataset.fits + (spot.dataset.hint ? ' ' + spot.dataset.hint : '');
      else {
        const areas = rec.map(r => { const [a, b] = dims(r); return a * b; }), fmt = r => dims(r).join(' × ');
        const range = `${fmt(rec[0])} to ${fmt(rec[rec.length - 1])} in.`;
        txt.textContent = (area > Math.max(...areas) ? txt.dataset.big : txt.dataset.small) + ' ' + range;
      }
    };
    const pick = sp => { spot = sp; spots.forEach(o => o.setAttribute('aria-pressed', o === sp ? 'true' : 'false')); size = sp.dataset.default || list(sp)[0] || (sizes[0] && sizes[0].dataset.ptwSize); draw(); };
    spots.forEach(b => b.addEventListener('click', () => pick(b)));
    sizes.forEach(b => b.addEventListener('click', () => { size = b.dataset.ptwSize; draw(); }));
    lights && lights.addEventListener('click', () => {
      const off = lights.getAttribute('aria-checked') !== 'true', lab = lights.querySelector('[data-on]');
      lights.setAttribute('aria-checked', off ? 'true' : 'false');
      stage.dataset.lights = off ? 'off' : 'on';
      lab.textContent = off ? lab.dataset.on : lab.dataset.off;
      off ? print.setAttribute('filter', print.dataset.filter) : print.removeAttribute('filter');
    });
    if (spots[0]) pick(spots[0]);
  };

  const init = root => {
    if (root.dataset.ptwReady) return;
    root.dataset.ptwReady = '1';
    root.querySelectorAll('[data-ptw-tile]').forEach(el => { const a = getComputedStyle(el).getPropertyValue('--a'); el.style.setProperty('--gs', strength(luma(hex(a))).toFixed(3)); });
    root.querySelectorAll('[data-ptw-room]').forEach(Room);
    root.querySelectorAll('[data-ptw-check]').forEach(Check);
    root.querySelectorAll('[data-ptw-uses]').forEach(Uses);
    root.querySelectorAll('[data-ptw-fit]').forEach(Fit);
    const live = new IntersectionObserver(es => es.forEach(e => e.target.classList.toggle('is-live', e.isIntersecting)));
    root.querySelectorAll('[data-ptw-live]').forEach(el => live.observe(el));
  };

  const boot = () => document.querySelectorAll('[data-ptw]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
